import { makeObservable, observable, action, runInAction, toJS } from 'mobx'
import { restaurantCenter } from 'restaurant'
import { store, ddayjs } from '@dt/fe-utils'
import { mallConfig } from '@mobx/mall'
import { uniqueId } from '@dt/fe-utils/dist/lodash'

interface ISetConfig {
  app?: 'pos' | 'mobile' | 'mini';
  /** 默认置入品牌ID */
  brandId?: number;
  /** 默认置入门店ID */
  storeId?: number;
  /** 置入桌台 和 店码，只用于非POS端 */
  tableCode?: string;
  codeType?: 'brand' | 'store' | 'table';
  /** 点餐模式 category为pos的点餐方式每次只显示一个分类 */
  displayMode?: 'category' | 'waterfall' | 'classic' | 'list';
  /** 营销计算器 */
  mpc?: any;
  /** 费的计算器 */
  fee?: any;
  /** 设备Id */
  deviceId?: string;
  /** 登录人ID */
  managerId?: string;
  /** 登录姓名 */
  managerName?: string;
  bo?: string;
  language?: TLanguage;
  lbs?: {
    lat: number;
    lng: number;
  };
  member?: {
    type: 'member' | 'user' | 'virtual' | 'visitor';
    id?: string;
    mobile?: string;
    email?: string;
    nickName?: string;
    key?: string;
    openId?: string;
    avatar?: string;
  };
  promotionId?: number;
  signal?: object;
}

let handleId: number = 0
function getHandleId () {
  return ++handleId
}
// enum TRestaurantDisabledReason {
//   Soldout = 'Soldout', // 售罄
//   CanNotTogo = 'CanNotTogo', // 不能外带
//   Expired = 'Expired' // 不存在
// }
export enum TCartitemDisabledReason {
  /** 售罄，或可售份数不够 */
  SOLDOUT = 'SOLDOUT',
  /** 场景的变化导致餐品不可外带（暂不支持） */
  CANNOTTOGO = 'CANNOTTOGO',
  /** 餐品不存在（不再在菜单中） */
  EXPIRED = 'EXPIRED',
  /** 条件不足（套餐中必要餐品不在菜单中） */
  NOCONDITION = 'NOCONDITION'
}
// 为了通用性使用object类型 HACK
export const RESTAURANT_EVENT = {
  /** 初始化 */
  RESTAURANT_INIT: 'RESTAURANT_INIT',
  /** 菜单排序或颜色变更 */
  MENU_EXT_REFRESH: 'MENU_EXT_REFRESH',
  /** 菜单刷新 开始事件 */
  MENU_START: 'MENU_START',
  /** 菜单刷新 应用事件 */
  MENU_APPLY: 'MENU_APPLY',
  /** 菜单刷新 结束事件 */
  MENU_END: 'MENU_END',
  /** 菜单更新预警（pos 提前3分钟 mobile 提前1分钟） */
  MENU_WILL_UPDATE: 'MENU_WILL_UPDATE',
  /** 菜单状态发生变化 */
  MENU_REFRESH: 'MENU_REFRESH',
  /** 菜单可用性变化（提前加载菜单，实际到了可用状态） */
  MENU_AVAILABLE: 'MENU_AVAILABLE',
  /** 餐品变更, （菜单需要刷新） */
  PRODUCT_CHANGED: 'PRODUCT_CHANGED',
  /** 餐品售卖状态变更 */
  PRODUCT_SALE_CHANGED: 'PRODUCT_SALE_CHANGED',
  /** 购物车餐品不可用(当前是通过餐品disabled的变化而来判断是否不可用，当不可用变成可用是亦会触发) */
  CART_ITEMS_INVALID: 'CART_ITEMS_INVALID',
  /** 购物车餐品的价格发生变化 */
  CART_ITEMS_PRICE_UPDATE: 'CART_ITEMS_PRICE_UPDATE',
  /** 购物车餐品发生变成 */
  CART_ITEMS_CHANGED: 'CART_ITEMS_CHANGED',
  /** 购物车餐品批量发生变成 */
  CART_ITEMS_BATCH_CHANGED: 'CART_ITEMS_BATCH_CHANGED',
  /** 购物车信息发生变化 */
  CART_INFO_CHANGED: 'CART_INFO_CHANGED',
  /** 购物车已下单餐品发生变化 */
  CART_ORDERITEMS_CHANGED: 'CART_ORDERITEMS_CHANGED',
  /** 购物车 变化 废弃 */
  CART_CHANGED: 'CART_CHANGED',
  /** 购物车重置 */
  CART_RESET: 'CART_RESET',
  /** 下单(包括save的各种形态) */
  SAVE_ORDER: 'SAVE_ORDER',
  /** 取消订单 */
  CANCEL_ORDER: 'CANCEL_ORDER',
  /** 支付 */
  PAY_ORDER: 'PAY_ORDER',
  /** 可以自动组合成套餐 */
  COMBO_AUTO: 'COMBO_AUTO',
  /** 品牌信息变化 */
  BRAND_CHANGED: 'BRAND_CHANGED',
  /** 门店信息变化 */
  STORE_CHANGED: 'STORE_CHANGED',
  /** 后付费加载订单信息开始 */
  ORDER_GET_START: 'ORDER_GET_START',
  /** 后付费加载订单信息结束 */
  ORDER_GET_END: 'ORDER_GET_END',
  /** 订单的状态发生变化（一般用于待接单订单 接单） */
  ORDER_STATUS_CHANGED: 'ORDER_STATUS_CHANGED',
  /** 限售状态： true: 成功， false： 失败 */
  PRODUCT_SALE_SYNC_STATUS: 'PRODUCT_SALE_SYNC_STATUS',
  /** Fee变更事件（只会在注入之后又发生变更才会发生） */
  FEE_CONFIG_UPDATED: 'FEE_CONFIG_UPDATED',
  /** Fee 需要刷新的事件 */
  FEE_CONFIG_REFRESH: 'FEE_CONFIG_REFRESH',
  /** mpc 变更事件 （只会在注入之后又发生变更才会发生） */
  CONFIG_MPC_UPDATED: 'CONFIG_MPC_UPDATED',
  /** location LBS信息更新 */
  CONFIG_LOCATION_UPDATED: 'CONFIG_LOCATION_UPDATED',
  /** 显示模式切换事件 */
  CONFIG_DISPLAYMODE_UPDATED: 'CONFIG_DISPLAYMODE_UPDATED',
  /** 切换语言包 */
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  /** 会员登录状态变更事件 */
  CONFIG_MEMBER_CHANGED: 'CONFIG_MEMBER_CHANGED',
  /** 删除云端购物车 */
  ORDER_CART_DELETED: 'ORDER_CART_DELETED',
  /** 用餐人数变化 */
  EATING_PERSON_CHANGE: 'EATING_PERSON_CHANGE',
  /** 就餐类型发生变化 */
  EAT_TYPE_CHANGE: 'EAT_TYPE_CHANGE',
  /** 商城切换回菜单 */
  MENU_MALL_CHANGE: 'MENU_MALL_CHANGE',
  /** 商城购物车更新 */
  SHOPCART_ITEMS_CHANGED: 'SHOPCART_ITEMS_CHANGED'
}

export class Console {
  private key: string
  constructor (key: string) {
    this.key = key
  }
  log (...args: any) {
    if (mallConfig.signal[this.key]) {
      (window as any).console.log(...args)
    }
  }
  error (...args: any) {
    (window as any).console.error(...args)
  }
  warn (...args: any) {
    (window as any).console.warn(...args)
  }
  toJS (...args: any[]) {
    if (mallConfig.signal[this.key]) {
      (window as any).console.log(...args.map(arg => toJS(arg)))
    }
  }
}

/**
 * 餐厅消息中心处理，在此汇总点餐事件，可提供监听事件
 * 是系统pubSub的子集，将在此汇集餐厅事件，也可以使用pubsub来全局使用
 */
class RestaurantCenter {
  constructor () {
    makeObservable(this, {
      config: observable,
      setConfig: action
    })
    restaurantCenter.on(RESTAURANT_EVENT.CHANGE_LANGUAGE, () => {
      const mpc = this.config.mpc
      if (mpc && mpc.eatType === 'mall') {
        this.init()
      }
    })
  }
  private eventBus: Record<string, any> = {}
  private handleMap: Record<string, any> = {}
  private onceHandleMap: Record<string, any> = {}
  private delayEvent: {
    /** 延迟的时间（放入时） */
    delay: number;
    /** 事件 */
    event: string;
    /** 触发的时刻 */
    trigger: number;
    /** 事件的data */
    data?: any;
    /** timeOut的handleId */
    handleId: any; // 实际是个number
  }[] = []

  config: IRestaurantConfig = {
    brandId: 0,
    storeId: 0,
    app: 'mobile',
    displayMode: 'waterfall',
    codeType: 'store',
    bo: 'us',
    language: 'en-US',
    earlyTime: 1 * 60 * 1000, // ms
    mpc: undefined,
    fee: null,
    lbs: {
      lat: 0,
      lng: 0
    },
    autoMergeCartItem: false,
    posAllCategories: false,
    posAllCategoriesNo: '-999',
    posOrderPageSize: 300,
    defaultModifierSpecial: true,
    shouldDispPersonModal: false,
    defaultOptionalComboPlace: true,
    deviceInfo: {},
    sourceType: '',
    hideOpenPriceProduct: false,
    signal: store.get('restaurant.signal') || {} // console.discount console.fee console.menu console.product console.cart
  }

  RESTAURANT_EVENT = RESTAURANT_EVENT

  /** 制造一个事件 */
  emit (event: string, data?: any) {
    this.broadcast(event, data)
  }

  /** 广播一个事件 */
  broadcast (event: string, data: any) {
    if (this.eventBus[event]) {
      for (const handleId in this.eventBus[event]) {
        runInAction(() => this.eventBus[event][handleId](data))
        // this.eventBus[event][handleId](data)
        // 对于处理一次的事件，触发即销毁
        this.off(handleId)
        delete this.onceHandleMap[handleId]
      }
    }
  }

  /** 取消一个订阅，如果传入句柄则取消某一个订阅 */
  off (eventOrHandleId: string | number | number[]) {
    if (typeof eventOrHandleId === 'string') {
      delete this.eventBus[eventOrHandleId]
    } else {
      const handleIds = typeof eventOrHandleId === 'number' ? [eventOrHandleId] : eventOrHandleId
      handleIds.forEach((handleId) => {
        const event = this.handleMap[handleId]
        if (event) {
          delete this.eventBus[event][handleId]
          delete this.handleMap[handleId]
        }
      })
    }
  }

  /** 监听一个事件或多个事件 */
  /* eslint-disable no-dupe-class-members */
  on (event: string, callback: (data?: any) => any): number;
  on (event: string[], callback: (data?: any) => any): number[];
  on (event: string | string[], callback: (data?: any) => any): number | number[] {
    if (Array.isArray(event)) {
      return event.map((e: string) => this.on(e, callback)) as number[]
    } else {
      if (!this.eventBus[event]) {
        this.eventBus[event] = {}
      }
      const handleId = this.config.app === 'pos' ? ~~uniqueId() : getHandleId()
      this.eventBus[event][handleId] = callback
      this.handleMap[handleId] = event
      return handleId
    }
  }

  /** 监听一次的事件（触发一次后会自动off） */
  once (event: string, callback: (data?: any) => any) {
    const theOnceHandleId = this.on(event, callback)
    this.onceHandleMap[theOnceHandleId] = 1
    return theOnceHandleId
  }

  /** 查询所有的事件 */
  get () {
    return this.eventBus
  }

  /** 查询当前的延迟事件 */
  getDelay () {
    return this.delayEvent
  }

  /** 延迟时间制造点(当前不支持持久化) */
  delay (delay: number, event: string, data?: any) {
    const timeOutHandleId = setTimeout(() => {
      this.emit(event, data)
      const handleIdIndex = this.delayEvent.findIndex(d => d.handleId === timeOutHandleId)
      if (~handleIdIndex) {
        this.delayEvent.splice(handleIdIndex, 1)
      }
    }, delay)
    this.delayEvent.push({
      delay,
      trigger: ddayjs().add(delay, 'ms').valueOf(),
      event,
      data,
      handleId: timeOutHandleId
    })
    return timeOutHandleId
  }

  /** 取消延迟事件,参数为事件名或者handleId */
  clearDelay (event?: any) {
    this.delayEvent = this.delayEvent.filter(e => {
      if (typeof event === 'string' ? e.event === event : e.handleId === event) {
        clearTimeout(e.handleId)
        return false
      } else {
        return true
      }
    })
  }

  /** 初始化用于初次初始化整个相关的服务 */
  init (config?: ISetConfig) {
    if (config) {
      // keep quote
      this.setConfig(config)
    }
    this.emit(RESTAURANT_EVENT.RESTAURANT_INIT)
  }

  /** 刷新菜单，同时更新 */
  initAll () {
    this.init()
    this.emit(RESTAURANT_EVENT.FEE_CONFIG_REFRESH)
  }

  /** 设置state 主要用于开关状态机 */
  setState (cfg: string, value?: boolean) {
    //  value 不置入如果原先有值则置反，否则置真
    const setv = typeof value === 'undefined' ? (typeof this.config.signal[cfg] === 'undefined' ? true : !this.config.signal[cfg]) : value
    this.config.signal[cfg] = setv
    store.set('restaurant.signal', toJS(this.config.signal))
  }
  /** 设置配置 */
  setConfig<T extends keyof ISetConfig> (scfg: T | ISetConfig, value?: ISetConfig[T]) {
    if (typeof scfg === 'string') {
      if (typeof value !== 'undefined') {
        // 处理状态机
        scfg = {
          [scfg]: value
        }
      } else {
        return
      }
      // (this.config as any)[scfg] = value
    }
    const cfg = scfg as ISetConfig
    // 一次fee变更行为  && this.config.fee
    if (cfg.fee) {
      this.config.fee = cfg.fee
      this.emit(RESTAURANT_EVENT.FEE_CONFIG_UPDATED)
    }
    // 一次cfg 发生变化
    if (typeof cfg.mpc !== 'undefined') {
      this.config.mpc = cfg.mpc
      this.emit(RESTAURANT_EVENT.CONFIG_MPC_UPDATED)
    }
    /** lbs 发生变化 */
    if (cfg.lbs) {
      this.emit(RESTAURANT_EVENT.CONFIG_LOCATION_UPDATED, cfg.lbs)
    }
    if (cfg.displayMode && this.config.displayMode) {
      this.emit(RESTAURANT_EVENT.CONFIG_DISPLAYMODE_UPDATED, cfg.displayMode)
    }
    this.config = Object.assign(this.config, cfg)
    // 菜单变更预警时间 pos 10秒钟 mobile 1分钟
    if (cfg.app === 'pos') {
      this.config.earlyTime = 10 * 1000
    } else if (cfg.app === 'mobile') {
      this.config.earlyTime = 1 * 60 * 1000
    }
    if (cfg.member) {
      this.emit(RESTAURANT_EVENT.CONFIG_MEMBER_CHANGED, cfg.member)
    }
    if (this.config.bo === 'cn') {
      this.config.defaultModifierSpecial = false
    } else {
      this.config.defaultModifierSpecial = true
    }
    return this.config
  }
}

export default new RestaurantCenter()
